import axios from 'axios'
import { LEADSORIGIN_ENDPOINT } from 'cfgCommon/endpoints'

export async function getOpportunityOrigins(isFilter = false, isManual = false, isMassive = false) {
  try {
    const response = await axios.get(`${LEADSORIGIN_ENDPOINT}/getOpportunityOrigins`, {
      params: {
        is_filter: isFilter,
        is_manual: isManual,
        is_massive: isMassive
      }
    })
    const origins = response?.data?.data
    if (!Array.isArray(origins)) {
      return []
    }

    return origins.map((origin) => {
      return {
        label: origin,
        value: origin
      }
    })
  } catch (error) {
    console.error('Error fetching opportunity origins', error)
    return []
  }
}
